import React from "react";
import "./catering-ads-space-section-theme2.scss";

const AdsSpaceSectionMainTheme2 = ({ adsDetails }) => {
  return (
    <>
      {adsDetails && adsDetails.ads_image ? (
        <div className="catering-ads-space-section-department">
          <a href={`${adsDetails.ads_url}`} target="_blank" rel="noreferrer">
            <img src={adsDetails.ads_image} alt="ads" />
          </a>
        </div>
      ) : (
        ""
      )}
    </>
  );
};
export default AdsSpaceSectionMainTheme2;
